import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DeckingBoardsService } from '../../../../services/configurators-2d/applications/decking-boards.service';
import { DeckingBoardType } from '../../../../models/configurators-2d/applications/decking-boards/decking-board-type';
import { DeckingBoard } from '../../../../models/configurators-2d/applications/decking-boards/decking-board';
import { DeckingBoardFinishingType } from '../../../../models/configurators-2d/applications/decking-boards/decking-board-finishing-type';
import { DeckingBoardFinishing } from '../../../../models/configurators-2d/applications/decking-boards/decking-board-finishing';
import { DeckingBoardsConfiguratorItem } from '../../configurator/applications/decking-boards-configurator-item';
import { IBaseComponent } from '../../configurator/i-base-component';
import { LayingTypeEnum } from 'src/app/enum/decking-boards/laying-type.enum';
import { DeckingBoardTypeEnum } from 'src/app/enum/decking-boards/decking-board-type.enum';
import { MODAL, ModalService } from 'src/app/services/modal.service';
import { DeckingBoardsPreviewComponent } from '../preview/preview.component';
import { Configurators2DComponent } from '../../configurators-2d.component';
import { Joist } from 'src/app/models/configurators-2d/applications/decking-boards/joist';
import { FixationGroup } from 'src/app/models/configurators-2d/applications/decking-boards/fixation-group';
import { JoistType } from 'src/app/enum/decking-boards/joist-type.enum';
import { CheckConfigurationSides } from 'src/app/models/configurators-2d/applications/decking-boards/configuration';

@Component({
  selector: 'ng-decking-boards-finishes',
  templateUrl: './finishes.component.html',
})
export class DeckingBoardsFinishesComponent extends DeckingBoardsConfiguratorItem implements OnInit, IBaseComponent {
  deckingBoards: DeckingBoard[];
  deckingBoardTypes: DeckingBoardType[];
  deckingBoardFinishings: DeckingBoardFinishing[];
  deckingBoardFinishingTypes: DeckingBoardFinishingType[];
  joists: Joist[];
  fixationGroups: FixationGroup[];

  //URL de base des images
  baseImgURL: string = undefined;

  //Sous étape
  subStep: number = 1;

  // Tooltip
  unvailableBoards: String;

  preview: DeckingBoardsPreviewComponent;

  constructor(
    private translate: TranslateService,
    private modalService: ModalService,
    deckingBoardsService: DeckingBoardsService,
    configurators2DComponent: Configurators2DComponent
  ) {
    super(deckingBoardsService);
    this.baseImgURL = this.service.apiUrl;
    this.preview = configurators2DComponent.preview as DeckingBoardsPreviewComponent;
  }

  ngOnInit(): void {
    Promise.all([
      this.service.getDeckingBoards().then(deckingBoards => (this.deckingBoards = deckingBoards)),
      this.service.getDeckingBoardTypes().then(deckingBoardTypes => (this.deckingBoardTypes = deckingBoardTypes)),
      this.service
        .getDeckingBoardFinishings()
        .then(deckingBoardFinishings => (this.deckingBoardFinishings = deckingBoardFinishings)),
      this.service
        .getDeckingBoardFinishingTypes()
        .then(deckingBoardFinishingTypes => (this.deckingBoardFinishingTypes = deckingBoardFinishingTypes)),
      this.service.getJoists().then(joists => (this.joists = joists)),
      this.service.getFixationGroups().then(fixationGroups => (this.fixationGroups = fixationGroups)),
    ]).then(() => {
      if (this.configuration.deckingBoardTypeId) {
        this.configuration.deckingBoardType = this.deckingBoardTypes.find(
          x => x.id == this.configuration.deckingBoardTypeId
        );
      }

      // Si on possède une lame on check si elle existe.
      if (this.configuration.deckingBoardId || this.configuration.deckingBoard) {
        let isDeckingBoardInList;

        if (this.configuration?.deckingBoard != undefined) {
          isDeckingBoardInList = this.deckingBoards.find(x => x.id == this.configuration.deckingBoard.id);
        }
        if (isDeckingBoardInList == undefined && this.configuration.deckingBoardId) {
          isDeckingBoardInList = this.deckingBoards.find(x => x.id == this.configuration.deckingBoardId);
        }
        if (isDeckingBoardInList != undefined) {
          this.configuration.deckingBoard = isDeckingBoardInList;
        } else {
          this.configuration.deckingBoard.displayOrder = -1;
          this.deckingBoards.unshift(this.configuration.deckingBoard);
        }
      }

      if (this.configuration.deckingBoardFinishingTypeId) {
        this.configuration.deckingBoardFinishingType = this.deckingBoardFinishingTypes.find(
          x => x.id == this.configuration.deckingBoardFinishingTypeId
        );
      }

      if (this.configuration.deckingBoardFinishingId) {
        this.configuration.deckingBoardFinishing = this.deckingBoardFinishings.find(
          x => x.id == this.configuration.deckingBoardFinishingId
        );
      }

      // Si on possède une lambourde on check si elle existe.
      if (this.configuration.joistId || this.configuration.joist) {
        let isJoistInList: Joist;

        if (this.configuration?.joist != undefined) {
          isJoistInList = this.joists.find(x => x.id == this.configuration.joist.id);
        }
        if (isJoistInList == undefined && this.configuration.joistId) {
          isJoistInList = this.joists.find(x => x.id == this.configuration.joistId);
        }
        if (isJoistInList != undefined) {
          this.configuration.joist = isJoistInList;
        } else {
          this.configuration.joist.displayOrder = -1;
          this.joists.unshift(this.configuration.joist);
        }

        // On vérifie que la lambourde est compatible avec la lame, si déréférencé on ajoute.
        if (
          this.configuration.hasValidQuotation &&
          isJoistInList.compaptibleDeckingBoardsIds.find(id => id == this.configuration.deckingBoard.id) == undefined
        ) {
          this.joists
            .find(x => x.id == this.configuration.joist.id)
            .compaptibleDeckingBoardsIds.push(this.configuration.deckingBoard.id);
        }
      }

      // Si on possède un groupe de fixation on check si elle existe.
      if (this.configuration.fixationGroupId || this.configuration.fixationGroup) {
        let isFixationGroupInList: FixationGroup;

        if (this.configuration?.fixationGroup != undefined) {
          isFixationGroupInList = this.fixationGroups.find(x => x.id == this.configuration.fixationGroup.id);
        }
        if (isFixationGroupInList == undefined && this.configuration.fixationGroupId) {
          isFixationGroupInList = this.fixationGroups.find(x => x.id == this.configuration.fixationGroupId);
        }
        if (isFixationGroupInList != undefined) {
          this.configuration.fixationGroup = isFixationGroupInList;
        } else {
          this.configuration.fixationGroup.displayOrder = -1;
          this.fixationGroups.unshift(this.configuration.fixationGroup);
        }

        // On vérifie que la lambourde est compatible avec la lame, si déréférencé on ajoute.
        if (
          this.configuration.hasValidQuotation &&
          isFixationGroupInList.compaptibleDeckingBoardsIds.find(id => id == this.configuration.deckingBoard.id) ==
            undefined
        ) {
          this.fixationGroups
            .find(x => x.id == this.configuration.fixationGroup.id)
            .compaptibleDeckingBoardsIds.push(this.configuration.deckingBoard.id);
        }
        if (
          this.configuration.hasValidQuotation &&
          isFixationGroupInList.compaptibleJoistsIds.find(id => id == this.configuration.joist.id) == undefined
        ) {
          this.fixationGroups
            .find(x => x.id == this.configuration.fixationGroup.id)
            .compaptibleJoistsIds.push(this.configuration.joist.id);
        }
      }

      this.preview.update();
    });

    this.unvailableBoards =
      this.translate.instant('decking-boards.finishes.unavailable-boards-laying-type') +
      ' (<' +
      this.getStraightLength() +
      ' cm)';
  }

  getStraightLength() {
    return this.configuration.configurationSides.find(s => s.name === 'A')?.length;
  }

  /**
   * Fonction d'affichage de la modal d'infos des structures
   * @param type type de modal à afficher
   */
  getInfos(type: string) {
    if (type === 'class') {
      this.subStep = 0;
      let _modalId: number = MODAL.DECKING_BOARDS_CLASS_INFO;
      this.modalService.display(_modalId, {});
    }
  }

  /**
   * Fonction d'affichage des sous menus
   * @param subStep sous étape
   */
  toggleCollapse(subStep: number) {
    if (subStep === this.subStep) {
      this.subStep = 0;
    } else {
      switch (subStep) {
        case 1:
          this.subStep = subStep;
          break;

        case 2:
          if (this.configuration.deckingBoardType !== null) {
            this.subStep = subStep;
          }
          break;

        case 3:
          if (this.configuration.deckingBoardType !== null && this.isDeckingBoardValid()) {
            this.subStep = subStep;
          }
          break;

        case 4:
          if (this.configuration.deckingBoardType !== null && this.isJoistValid()) {
            this.subStep = subStep;
          }
          break;
      }
    }
  }

  /**
   * Retourne si le type bois est sélectionné
   * @param deckingBoardType
   * @returns
   */
  isWoodSelected(deckingBoardType: DeckingBoardType) {
    return deckingBoardType?.type == DeckingBoardTypeEnum.wood;
  }

  /**
   * Fonction de détermination si le deckingBoardType est sélectionné ou non
   * @param id id deckingBoardType
   * @returns boolean
   */
  isDeckingBoardTypeSelected(id: number) {
    if (this.hasTypeActiveBoards) {
      return this.configuration.deckingBoardType?.id === id;
    }
  }

  hasTypeActiveBoards(id: number) {
    let deckingboards = this.getDeckingBoards(id);
    return deckingboards.length > 0;
  }

  /**
   * Fonction de détermination si le DeckingBoard est sélectionné ou non
   * @param id id DeckingBoard
   * @returns boolean
   */
  isDeckingBoardSelected(id: number) {
    return this.configuration.deckingBoard?.id === id;
  }

  /**
   * Fonction de détermination si le DeckingBoardFinishingType est sélectionné ou non
   * @param id id DeckingBoardFinishingType
   * @returns boolean
   */
  isDeckingBoardFinishingTypeSelected(id: number) {
    return this.configuration.deckingBoardFinishingType?.id === id;
  }

  /**
   * Fonction de détermination si le DeckingBoardFinishing est sélectionné ou non
   * @param id id DeckingBoardFinishing
   * @returns boolean
   */
  isDeckingBoardFinishingSelected(id: number) {
    return this.configuration.deckingBoardFinishing?.id === id;
  }

  /**
   * Fonction de sélection de la DeckingBoard
   * @param deckingBoard
   */
  async selectDeckingBoard(deckingBoard: DeckingBoard): Promise<void> {
    this.configuration.deckingBoard = deckingBoard;
    this.configuration.deckingBoardFinishingType = null;
    this.configuration.deckingBoardFinishing = null;

    await this.preview.update();
    this.toggleCollapse(3);
  }

  /**
   * Fonction de sélection de la DeckingBoardType
   * @param deckingBoardType
   */
  async selectDeckingBoardType(deckingBoardType: DeckingBoardType): Promise<void> {
    if (this.hasTypeActiveBoards(deckingBoardType.id)) {
      this.configuration.deckingBoardType = deckingBoardType;
      this.configuration.deckingBoard = null;
      this.configuration.deckingBoardFinishingType = null;
      this.configuration.deckingBoardFinishing = null;

      await this.preview.update();

      this.toggleCollapse(2);
    }
  }

  /**
   * Fonction de sélection de la DeckingBoardFinishingType
   * @param deckingBoardFinishingType
   */
  selectDeckingBoardFinishingType(deckingBoardFinishingType: DeckingBoardFinishingType) {
    this.configuration.deckingBoardFinishing = null;
    this.configuration.deckingBoardFinishingType = deckingBoardFinishingType;
  }

  /**
   * Fonction de sélection de la DeckingBoardFinishing
   * @param deckingBoardFinishing
   */
  selectDeckingBoardFinishing(deckingBoardFinishing: DeckingBoardFinishing) {
    this.configuration.deckingBoardFinishing = deckingBoardFinishing;
  }

  /**
   * Fonction de sélection du premier DeckingBoardFinishingType si il est seul dans la liste
   */
  autoSelectDeckingBoardFinishingType(deckingBoardFinishingTypes: DeckingBoardFinishingType[]) {
    if (this.configuration.deckingBoard != null && deckingBoardFinishingTypes.length === 1) {
      this.selectDeckingBoardFinishingType(deckingBoardFinishingTypes[0]);
    }
  }

  /**
   * Fonction de sélection du premier DeckingBoardFinishing si il est seul dans la liste
   */
  autoSelectDeckingBoardFinishing(deckingBoardFinishings: DeckingBoardFinishing[]) {
    if (this.configuration.deckingBoardFinishingType != null && deckingBoardFinishings.length === 1) {
      this.selectDeckingBoardFinishing(deckingBoardFinishings[0]);
    }
  }

  hasFinishings(): boolean {
    return (
      this.configuration.configurationSides.filter(s => s.hasFinishing).length > 0 &&
      this.deckingBoards?.filter(
        d =>
          d.deckingBoardTypeId === this.configuration.deckingBoardType?.id &&
          this.deckingBoardFinishings.filter(f => f.deckingBoardId === d.id).length > 0
      ).length > 0
    );
  }

  /**
   * Compte le nombre de teintes et finitions disponibles en fonction du matériaux sélectionné
   * @param id du DeckingBoardType
   */
  countDeckingBoards(id: number): number {
    return this.getDeckingBoards(id)?.length;
  }

  /**
   * Récupère les teintes et finitions disponibles en fonction du matériaux sélectionné et de s'il y a des finitions
   * @param id de DeckingBoardType
   */
  getDeckingBoards(id?: number): DeckingBoard[] {
    if (id == null) {
      return [];
    }

    let deckingBoards = this.deckingBoards?.filter(d => d.deckingBoardTypeId === id);

    if (this.configuration.layingType.type === LayingTypeEnum.Straight) {
      deckingBoards = deckingBoards.filter(d => d.length >= this.getStraightLength());
    }

    /* Retrait des finitions traitement back actuellement */
    /*if (this.hasFinishings()) {
      // On récupère l'id du type correspondant au bois.
      const woodId = this.deckingBoardTypes.find(dt => dt.type == DeckingBoardTypeEnum.wood).id;
      deckingBoards = deckingBoards.filter(d => 
        d.deckingBoardTypeId == woodId ||
        this.deckingBoardFinishings.filter(f => f.deckingBoardId === d.id).length > 0);
    }*/

    // deckingBoards?.sort((a, b) => {
    //   if(this.configuration?.deckingBoardType?.type == DeckingBoardTypeEnum.composite){
    //     return a.displayOrder;
    //   } else {
    //     return a.ean.nameFr.localeCompare(b.ean.nameFr ) || a.class - b.class;
    //   }
    // });

    deckingBoards?.sort((a, b) => {
      return a.displayOrder - b.displayOrder;
    });

    return deckingBoards;
  }

  /**
   * Compte le nombre finitions disponibles en fonction du matériaux sélectionné
   * @param deckingBoardFinishingTypeId
   * @param deckingBoardId
   */
  countDeckingBoardFinishings(deckingBoardFinishingTypeId: number, deckingBoardId: number): number {
    return this.getDeckingBoardFinishings(deckingBoardFinishingTypeId, deckingBoardId).length;
  }

  /**
   * Récupère les finitions disponibles en fonction du matériaux sélectionné
   * @param deckingBoardFinishingTypeId
   * @param deckingBoardId
   */
  getDeckingBoardFinishings(deckingBoardFinishingTypeId: number, deckingBoardId: number): DeckingBoardFinishing[] {
    let deckingBoardFinishings = this.deckingBoardFinishings.filter(
      f => f.deckingBoardFinishingTypeId === deckingBoardFinishingTypeId && f.deckingBoardId === deckingBoardId
    );

    this.autoSelectDeckingBoardFinishing(deckingBoardFinishings);

    return deckingBoardFinishings;
  }

  displayDeckingBoardFinishingTypes(): boolean {
    return this.deckingBoardFinishings.filter(f => f.deckingBoardId === this.configuration.deckingBoard?.id).length > 0;
  }

  getDeckingBoardFinishingTypes(): DeckingBoardFinishingType[] {
    let deckingBoardsFinishingTypes = this.deckingBoardFinishingTypes.filter(
      ft => this.countDeckingBoardFinishings(ft.id, this.configuration.deckingBoard?.id) > 0
    );

    this.autoSelectDeckingBoardFinishingType(deckingBoardsFinishingTypes);

    return deckingBoardsFinishingTypes;
  }

  /**
   * Récupère les lambourdes disponibles.
   * @returns
   */
  getJoists(deckingBoardId: number): Joist[] {
    let joists = this.joists;

    if (this.configuration.raisedHeight > 0) {
      joists = joists.filter(j => j.acceptPedestals && j.compaptibleDeckingBoardsIds.includes(deckingBoardId));
    } else {
      joists = joists.filter(j => j.compaptibleDeckingBoardsIds.includes(deckingBoardId));
    }

    // Filtre si pose à l'anglaise (bois et bois exotique acceptés)
    if (this.configuration.layingType.type == LayingTypeEnum.English) {
      joists = joists.filter(j => j.joistType == JoistType.Wood || j.joistType == JoistType.ExoticWood);
    }

    if (this.configuration.deckingBoard != null && joists.length === 1) {
      this.selectJoist(joists[0]);
    }

    joists?.sort((a, b) => {
      return a.displayOrder - b.displayOrder;
    });

    return joists;
  }

  /**
   * Fonction de sélection de la Joist
   * @param joist
   */
  selectJoist(joist: Joist) {
    this.configuration.joist = joist;

    this.toggleCollapse(4);
  }

  /**
   * Fonction de détermination si la lambourde est sélectionné ou non
   * @param id id joist
   * @returns boolean
   */
  isJoistSelected(id: number) {
    return this.configuration.joist?.id === id;
  }

  /**
   * Récupère les fixations disponibles.
   * @returns
   */
  getFixationGroups(deckingBoardId: number, joistId: number): FixationGroup[] {
    let fixationGroup = this.fixationGroups.filter(
      fg => fg.compaptibleDeckingBoardsIds.includes(deckingBoardId) && fg.compaptibleJoistsIds.includes(joistId)
    );

    if (this.configuration.deckingBoard != null && this.configuration.joist != null && fixationGroup.length === 1) {
      this.selectFixationGroup(fixationGroup[0]);
    }

    fixationGroup?.sort((a, b) => {
      return a.displayOrder - b.displayOrder;
    });

    return fixationGroup;
  }

  /**
   * Fonction de sélection du groupe de fixation
   * @param fixationGroup
   */
  selectFixationGroup(fixationGroup: FixationGroup) {
    this.configuration.fixationGroup = fixationGroup;
  }

  /**
   * Fonction de détermination si le groupe de fixation est sélectionné ou non
   * @param id id fixation group
   * @returns boolean
   */
  isFixationGroupSelected(id: number) {
    return this.configuration.fixationGroup?.id === id;
  }

  /**
   * Fonction qui vérifie si la lame est valide
   * Soit le devis est valide
   * Sinon elle ne doit pas être disable
   */
  isDeckingBoardValid(): boolean {
    return (
      this.configuration.hasValidQuotation ||
      (this.configuration?.deckingBoard !== null && !this.configuration?.deckingBoard?.isDisabled)
    );
  }

  /**
   * Fonction qui vérifie si la lambourde est valide$
   * Soit le devis est valide
   * Sinon elle ne doit pas être disable
   * Et la lame doit être valide.
   */
  isJoistValid() {
    return (
      this.configuration.hasValidQuotation ||
      (this.isDeckingBoardValid() && this.configuration?.joist !== null && !this.configuration?.joist?.isDisabled)
    );
  }

  isNextButtonActive(): boolean {
    let hasDeckingBoardSelected = this.configuration.deckingBoardType != null && this.isDeckingBoardValid();

    // Sélection auto de la finition dans le back donc plus de vérification
    let hasFinishingSelected = true;
    // if (this.configuration.configurationSides.filter(s => s.hasFinishing).length == 0) {
    //   hasFinishingSelected = true;
    // }
    // if (this.configuration.deckingBoardType?.type == DeckingBoardTypeEnum.wood || this.configuration.deckingBoardFinishing != null) {
    //   hasFinishingSelected = true;
    // }

    // Lambourde et fixation sélectionnée
    let hasJoistSelected = this.isJoistValid();
    let hasFixationGroupSelected = this.configuration.fixationGroup != null;

    return hasDeckingBoardSelected && hasFinishingSelected && hasJoistSelected && hasFixationGroupSelected;
  }

  checkPageChangeCapability(): boolean {
    return (
      this.configuration.shape != null &&
      this.configuration.layingType != null &&
      this.configuration?.configurationSides.find(x => x.length <= 0) == null &&
      CheckConfigurationSides(this.configuration)
    );
  }
}
